/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Conversation } from '../../models/conversation';
import { ConversationWithVaultsCreationData } from '../../models/conversation-with-vaults-creation-data';

export interface ConversationStartConversationWithVaults$Params {
      body: ConversationWithVaultsCreationData
}

export function conversationStartConversationWithVaults(http: HttpClient, rootUrl: string, params: ConversationStartConversationWithVaults$Params, context?: HttpContext): Observable<StrictHttpResponse<Conversation>> {
  const rb = new RequestBuilder(rootUrl, conversationStartConversationWithVaults.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Conversation>;
    })
  );
}

conversationStartConversationWithVaults.PATH = '/conversation/vaults';
